(function($) {
    "use strict";

	function checkHeader() {
		var darkbg = 0;
		$('.left-side .bg-img').each(function () {
			darkbg = darkbg + $(this).outerHeight();
		});

		if ($(document).scrollTop() < (darkbg - $('.navbar-brand').outerHeight())) {
			$('.navbar-brand').addClass('light');
		} else {
			$('.navbar-brand').removeClass('light');
		}
	}

    $(function() {

    	AOS.init({
			offset: 200,
			duration: 600,
			delay: 100,
			disable: 'mobile'
		});

		$('.jarallax').jarallax({
			speed: .15,
			imgPosition: '20% -3.5%',
			imgSize: '145%',
			imgRepeat: 'repeat-y'
		});

		$('.jarallax-secondary').jarallax({
			speed: .15,
			imgPosition: '50% 0',
			imgSize: '180%',
			imgRepeat: 'repeat-y'
		});

		$('.jarallax-technical').jarallax({
			speed: .15,
			imgPosition: '0% 20%',
			imgSize: '100%',
			imgRepeat: 'repeat-y'
		});

        $('.portfolios-slider').slick({
			infinite: true,
			slidesToShow: 1,
            dots: false,
			fade: true,
			cssEase: 'linear',
			adaptiveHeight: true
        });

        var block_first_before_height = $('.block.first').outerHeight() - $('.block.first .dot').outerHeight() / 2 - 47;
        var block_first_before_translateY = $('.block.first .dot').outerHeight() / 2 + 47;
        $( "<style>.left-side .block.first:before { height: " + block_first_before_height + "px; transform: translate(-122px, " + block_first_before_translateY + "px); opacity: 1;}</style>").appendTo( "head" );

		checkHeader();

		$(window).scroll(function () {
			checkHeader();
		});

		$('.js-banner-sample-btn').click(function () {
			$('body').addClass('banner-layer-active');
		});

		$('.icon-close').click(function () {
			$('body').removeClass('banner-layer-active');
		});
    });
})(jQuery);
